module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-10.ea1a6642.jpg";